<forge-scaffold role="region" aria-label="Tyler Assistant unavailable">
  <forge-toolbar slot="header">
    <h2 slot="start" class="forge-typography--heading4">Tyler Assistant</h2>
    <forge-icon-button slot="end" aria-label="Close Tyler Assistant" (click)="close()">
      <forge-icon name="close"></forge-icon>
    </forge-icon-button>
  </forge-toolbar>

  <div slot="body" class="assistant-unavailable__body">
    <forge-inline-message theme="warning">
      <span slot="title">Tyler Assistant is unavailable right now</span>
      <div>We couldn't connect to the assistant. You can still reach Tyler support directly.</div>
    </forge-inline-message>

    <forge-button variant="text" (click)="open(productSupportUrl)">
      <span>Client support and phone numbers</span>
      <forge-icon slot="end" name="open_in_new"></forge-icon>
    </forge-button>
    <forge-button variant="text" (click)="open(supportPortalUrl)">
      <span>Remote support portal</span>
      <forge-icon slot="end" name="open_in_new"></forge-icon>
    </forge-button>
  </div>

  <forge-toolbar slot="footer" inverted="true">
    <forge-button slot="end" variant="raised" (click)="tryAgain()">
      <forge-icon slot="start" name="refresh"></forge-icon>
      Try again
    </forge-button>
  </forge-toolbar>
</forge-scaffold>
